import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    checkPopupHints: true,
    classifyTree: null, // top and second level of classify tree
    topClassify: [],   // top level of classify tree
    curTopTab: null, // desktop mode current tab

    bandList: null, // settings for band listing page
    brandProductList: null, // settings for band product listing page
    classifyList: null, // settings for classify listing page
    classifyProductList: null,  // settings for classify product listing page
    productList: null,  // settings for product listing page (from search resule)
    newProductList: null,  // settings for new product listing page
    hotProductList: null,  // settings for hot product listing page
    promoProductList: null,  // settings for promo product listing page
    product: null,  // settings for product detail info page
    orderConfirmed: null,  // settings for order confirmed page

    member: {}, // current member info
    addresses: null,
    cartCount: 0, // last cart item count

    ioBaseURL: (Vue.config.devtools ? 'https://x.mrsdigi.com/digi/webapp.f3/app-baby.php' : '/api/'),
    ws1host: (Vue.config.devtools ? 'wss://wss.mrsdigi.com:8080/notify' : 'wss://wss.mrsdigi.com:8080/notify'),
  },
  mutations: {
    member(state, payload) {
      state.member = payload;
      if (Object.keys(payload).length == 0) {
        state.cartCount = 0;
        state.addresses = null;
      } else {
        localStorage.setItem("SessionToken", payload.SessionToken);

        let obj = {
          AppVersion: this.$version,
          SessionId: state.member.SessionId,
          SessionToken: state.member.SessionToken,
        };
        this._vm.$ajax2
          .post("GetMemberAddresses", obj, this._vm.$ajaxHeader)
          .then(function (rpdata) {
            if (rpdata.data.meta.code == "200") {
              state.addresses = rpdata.data.data;
            }
          })
          .catch(function (err) { }); // eslint-disable-line
      }
    },
    addresses(state, payload) { state.addresses = payload },
    cartCount(state, payload) { state.cartCount = payload },

    checkPopupHints(state, payload) { state.checkPopupHints = payload },
    classifyTree(state, payload) { state.classifyTree = payload },
    topClassify(state, payload) { state.topClassify = payload },
    curTopTab(state, payload) { state.curTopTab = payload },

    brandList(state, payload) { state.bandList = payload },
    brandProductList(state, payload) { state.brandProductList = payload },
    classifyList(state, payload) { state.classifyList = payload },
    classifyProductList(state, payload) { state.classifyProductList = payload },
    product(state, payload) { state.product = payload },
    productList(state, payload) { state.productList = payload },
    newProductList(state, payload) { state.newProductList = payload },
    hotProductList(state, payload) { state.hotProductList = payload },
    promoProductList(state, payload) { state.promoProductList = payload },
    orderConfirmed(state, payload) { state.orderConfirmed = payload },

    popup(state, payload) { state.popup = payload },
  },
  getters: {
    // routeCount: state => {
    //   return state.routeCount;
    // },
    // Detects if device is in standalone mode
    isInStandaloneMode: () => {
      return "standalone" in window.navigator && window.navigator.standalone;
    },
    isIosDevice: () => {
      const userAgent = window.navigator.userAgent.toLowerCase();
      return /iphone|ipad|ipod/.test(userAgent);
    },
    isAndroidDevice: () => {
      const userAgent = window.navigator.userAgent.toLowerCase();
      return /android/.test(userAgent);
    },
    isWechatBrowser: () => {
      const userAgent = window.navigator.userAgent.toLowerCase();
      return /micromessenger/.test(userAgent);
    },
    isMobile: (state, getters) => {
      return getters.isIosDevice || getters.isAndroidDevice;
    },
    isIosWebBased: (state, getters) => {
      return getters.isIosDevice && !getters.isInStandaloneMode;
    },
    // platform: state => {
    //   if (state.deviceInfo == null || state.deviceInfo.platform === undefined)
    //     return null;
    //   else
    //     return state.deviceInfo.platform;
    // },
    // deviceOS: state => {
    //   if (state.deviceInfo == null || state.deviceInfo.operatingSystem === undefined)
    //     return null;
    //   else
    //     return state.deviceInfo.operatingSystem;
    // },
    // isMobile: (state, getters) => {
    //   return /ios|android/.test(getters.deviceOS);
    // },
    // isNativeApp: (state, getters) => {
    //   return getters.platform != null && (getters.platform == 'device' || getters.platform == 'ios');
    // }
  }
});
export default store
